/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resquest to delete timeslots
 * @export
 * @interface TimeslotDeleteRequest
 */
export interface TimeslotDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof TimeslotDeleteRequest
     */
    timeslotIds?: Array<string>;
}

/**
 * Check if a given object implements the TimeslotDeleteRequest interface.
 */
export function instanceOfTimeslotDeleteRequest(value: object): value is TimeslotDeleteRequest {
    return true;
}

export function TimeslotDeleteRequestFromJSON(json: any): TimeslotDeleteRequest {
    return TimeslotDeleteRequestFromJSONTyped(json, false);
}

export function TimeslotDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotDeleteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeslotIds': json['timeslotIds'] == null ? undefined : json['timeslotIds'],
    };
}

export function TimeslotDeleteRequestToJSON(json: any): TimeslotDeleteRequest {
    return TimeslotDeleteRequestToJSONTyped(json, false);
}

export function TimeslotDeleteRequestToJSONTyped(value?: TimeslotDeleteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeslotIds': value['timeslotIds'],
    };
}

